import _pt from "prop-types";
import { IconAccordionCaretDown } from '@lmig/lmds-react-icons';
import React from 'react';
/** Icon container for icon included in the evolution experience */
export var IconEvo = function IconEvo(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    highlightType = _ref.highlightType;
  if (loading) return null;

  // iconColor defaulted to teal, then modified if other conditions are met
  var iconColor = 'teal';
  if (disabled) {
    iconColor = 'disabled';
  }

  // This is following the current priority order within select. highlightType takes priority
  if (highlightType === 'error') {
    iconColor = 'negative';
  }
  return /*#__PURE__*/React.createElement(IconAccordionCaretDown, {
    color: iconColor,
    size: "16",
    className: "lmig-Icon-evolution",
    ariaHidden: true
  });
};
IconEvo.propTypes = {
  /** Whether the select field is disabled
     * @default false
     */
  disabled: _pt.bool,
  /** Whether the select field is loading
     * @default false
     */
  loading: _pt.bool,
  /** The highlightType currently displayed on the select field */highlightType: _pt.oneOf(['error'])
};